$(".collection .collection-buttons_column-item").click(function(){
  $(".collection .collection-buttons_column-item").removeClass('active');
  $(this).addClass('active');
  var btn_id = $(this).attr('id');

  $(".collection .cu-multi-collecion-body").removeClass("active");
  $(this).parents('.collection').find(".cu-multi-collecion-body[id='" + btn_id + "']").addClass("active");
});

class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    const items = this.querySelectorAll('.sell-up-products_row .collection-buttons_column-item');
    items.forEach(item => {
      item.addEventListener('click', this.handleClick);
    });
  }
  handleClick(event) {
    const items = this.querySelectorAll('.sell-up-products_row .collection-buttons_column-item');
    items.forEach(item => {
      item.classList.remove('active');
    });
    const clickedItem = event.target;
    clickedItem.classList.add('active');
    const btnId = clickedItem.getAttribute('id');
    const bodies = this.querySelectorAll('.sell-up-products_row .cu-multi-collecion-body');
    bodies.forEach(body => {
      body.classList.remove('active');
    });
    const bodyToActivate = this.querySelector(`.sell-up-products_row .cu-multi-collecion-body[id='${btnId}']`);
    if (bodyToActivate) {
      bodyToActivate.classList.add('active');
    }
  }
  disconnectedCallback() {
    const items = this.querySelectorAll('.sell-up-products_row .collection-buttons_column-item');
    items.forEach(item => {
      item.removeEventListener('click', this.handleClick);
    });
  }
}
customElements.define('collection-tabs', CollectionTabs);